import React from 'react';
import { Link } from 'react-router-dom';

const colors = {
  mainBlue: "#061941",
  xanthous: "#F2AF29",
  isabelline: "#F4F3EE",
  carrieban: "#3C6E71",
  cafeNoir: "#583E23",
};

export default function HomePage() {
  return (
    <div
      style={{
        minHeight: "100vh",
        minWidth: "100vw",
        background: `linear-gradient(120deg, ${colors.mainBlue} 70%, ${colors.xanthous} 92%, ${colors.xanthous} 100%)`,
        display: "flex",
        flexDirection: "column",
        fontFamily: "Segoe UI, Arial, sans-serif"
      }}
    >
      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
          paddingTop: "4rem"
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "520px",
            background: colors.isabelline,
            padding: "3rem",
            borderRadius: "16px",
            boxShadow: `0 4px 24px 0 ${colors.cafeNoir}22`,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
        <h1
          style={{
            fontSize: "2.5rem",
            fontWeight: 800,
            fontFamily: "Poppins, Segoe UI, Arial, sans-serif",
            textAlign: "center",
            color: colors.mainBlue,
            marginBottom: "1rem",
            letterSpacing: "1.5px",
          }}
        >
          Let's Get Started
        </h1>
        <p
          style={{
            textAlign: "center",
            color: colors.mainBlue,
            fontSize: "1.18rem",
            marginBottom: "2.2rem",
            marginTop: "1rem",
            fontWeight: 500,
          }}
        >
          Connecting and empowering graduate students, instantly and personally.
        </p>
        <div style={{ display: "flex", flexDirection: "column", gap: "1.25rem" }}>
          <Link to="/role-selection" style={{ textDecoration: "none" }}>
            <button
              style={{
                width: "100%",
                padding: "1rem 0",
                background: colors.xanthous,
                color: colors.mainBlue,
                fontWeight: 700,
                border: "none",
                borderRadius: "10px",
                fontSize: "1.2rem",
                boxShadow: `0 2px 8px 0 ${colors.xanthous}33`,
                cursor: "pointer",
                transition: "background 0.13s, color 0.13s",
                outline: "none",
              }}
              aria-label="Sign Up"
            >
              Register
            </button>
          </Link>
          <Link to="/login" style={{ textDecoration: "none" }}>
            <button
              style={{
                width: "100%",
                padding: "1rem 0",
                background: colors.carrieban,
                color: colors.isabelline,
                fontWeight: 700,
                border: "none",
                borderRadius: "10px",
                fontSize: "1.2rem",
                boxShadow: `0 2px 8px 0 ${colors.carrieban}33`,
                cursor: "pointer",
                transition: "background 0.13s, color 0.13s",
                outline: "none",
              }}
              aria-label="Log In"
            >
              Log In
            </button>
          </Link>
        </div>
        </div>
      </div>
    </div>
  );
}